class PopupComponent extends HTMLElement {
  constructor() {
    super();

    const popup = document.querySelector(".navigation_popup");
    const popupContent = document.querySelector(".popup-content");
    const bodyEl = document.querySelector("body");

    const closeBtn = document.createElement("span");
    closeBtn.classList.add("close");
    closeBtn.textContent = "×";

    popupContent.appendChild(closeBtn);

    closeBtn.addEventListener("click", () => {
      popup.classList.add("hidden");
      bodyEl.style.overflow = "visible";
    });

    window.addEventListener("click", (e) => {
      if (e.target === popup) {
        popup.classList.add("hidden");
        bodyEl.style.overflow = "visible";
      }
    });

    this.openPopup = function () {
      popup.classList.remove("hidden");
      bodyEl.style.overflow = "hidden";
    };
  }

  connectedCallback() {
    const openPopupBtn = document.getElementById("openPopup");
    if (openPopupBtn) {
      openPopupBtn.addEventListener("click", () => {
        this.openPopup();
      });
    }
  }
}

customElements.define("popup-component", PopupComponent);


document.addEventListener("DOMContentLoaded", function () {
  const toggles = document.querySelectorAll(".menu-item__head");
  const currentUrl = window.location.href;
  const menuLinks = document.querySelectorAll(".menu a");
  const megaMenuLinks = document.querySelectorAll("[data-link]");

  // Clear active state if on the homepage
  if (window.location.pathname === "/") {
    localStorage.removeItem("activeCollection");
    localStorage.removeItem("activeheadMenuItem");
  }

  const allProducts = document.querySelector("#HeaderMenu-produkter");
  if (allProducts) {
    allProducts.addEventListener("click", () => {
      localStorage.removeItem("activeCollection");
      localStorage.removeItem("activeheadMenuItem");
    });
  }

  // Retrieve active states from localStorage
  const activeCollection = localStorage.getItem("activeCollection");
  const activeheadMenuItem = localStorage.getItem("activeheadMenuItem");

  // Handle megamenu links click events
  megaMenuLinks.forEach((link) => {
    link.addEventListener("click", function () {

      const linkTitle = this.getAttribute("data-link");
      localStorage.setItem("activeheadMenuItem", linkTitle);

      if (this.href && this.href.includes("/collections/")) {
        localStorage.setItem("activeCollection", this.href);
      }

      // Track the submenu that should be open
      const parentMenuItem = link.closest("li");
      if (parentMenuItem) {
        parentMenuItem.classList.add("active-link");
        const parentSubmenu = parentMenuItem.querySelector(".submenu");
        if (parentSubmenu) {
          parentSubmenu.style.maxHeight = "fit-content";
        }
      }
    });
  });










  // Reapply the active state on page load
  menuLinks.forEach((link) => {
    const parentTitle = link.getAttribute("data-title");

    link.addEventListener("click", function () {
      localStorage.setItem("activeCollection", this.href);

    })

    // Check if the link matches the activeCollection
    if (link.href === activeCollection) {
      link.parentElement.classList.add("active-link");

      const parentSubmenu = link.closest(".submenu");
      if (parentSubmenu) {
        parentSubmenu.style.maxHeight = "fit-content"; // Open submenu
        const parentMenuHead = parentSubmenu.previousElementSibling;
        parentMenuHead.classList.add("active");
      }

      // Also apply for head menu item if activeheadMenuItem matches
      const parentMenuHead = link.closest(".menu-item__head");

      if (parentMenuHead && parentTitle === activeheadMenuItem) {
        parentMenuHead.classList.add("active");
        const parentSubmenu = parentMenuHead.nextElementSibling;
        if (parentSubmenu) {
          parentSubmenu.style.maxHeight = "fit-content"; // Open submenu
        }
      }
    }
  });

  // Handle toggling submenus manually when clicked
  toggles.forEach(function (toggle) {
    toggle.addEventListener("click", function () {
      toggle.classList.toggle("active");
      const headMenuItem = toggle.getAttribute("data-title");
      localStorage.setItem("activeheadMenuItem", headMenuItem);

      const submenu = this.nextElementSibling;
      if (submenu) {
        if (submenu.style.maxHeight && submenu.style.maxHeight !== "0px") {
          submenu.style.maxHeight = "0px";
        } else {
          submenu.style.maxHeight = "fit-content";
        }
      }
    });
  });
});
